/* Matcha Sunday — custom supply/subscription picker logic.
   Click/keyboard driven (no radio inputs, Avada-safe). On selection it writes the
   chosen variant id into the product form's [name="id"] and a hidden
   [name="selling_plan"] (removed for one-time), so the theme's native Add to cart
   POSTs /cart/add.js with the standard {id, quantity, selling_plan} payload that
   Skio reads. Quantity stays handled by the theme's quantity selector. */
(function(){
  function getForm(root){
    var info = root.closest('.product-info') || document;
    return info.querySelector('form[action*="/cart/add"]')
        || document.querySelector('product-form form[action*="/cart/add"]')
        || document.querySelector('form[id^="product-form"]');
  }
  function idInput(form){
    if(!form) return null;
    var i = form.querySelector('[name="id"]');
    if(!i){ i=document.createElement('input'); i.type='hidden'; i.name='id'; form.appendChild(i); }
    return i;
  }
  function planInput(form){
    if(!form) return null;
    var i = form.querySelector('input[name="selling_plan"][data-ms]');
    if(!i){ i=document.createElement('input'); i.type='hidden'; i.name='selling_plan'; i.setAttribute('data-ms',''); form.appendChild(i); }
    return i;
  }
  function buyButton(form){
    if(!form) return null;
    return form.querySelector('[name="add"]')
        || form.querySelector('button[type="submit"]')
        || form.querySelector('.product-form__submit');
  }
  /* the quantity selector lives in its own <quantity-selector> element, OUTSIDE
     the cart form, so we look it up within the whole product-info scope. */
  function qtyInput(scope){
    if(!scope) return null;
    return scope.querySelector('quantity-selector [name="quantity"]')
        || scope.querySelector('[name="quantity"]');
  }
  function qtyValue(scope){
    var q = qtyInput(scope);
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }
  /* format a cents amount using the currency shape of a reference money string
     (e.g. "$39.99" -> "$" prefix, "" suffix). USD store, two decimals. */
  function fmtMoney(cents, ref){
    var num = (cents / 100);
    var prefix = (ref.match(/^[^\d]*/) || [''])[0];
    var suffix = (ref.match(/[^\d]*$/) || [''])[0];
    return prefix + num.toFixed(2) + suffix;
  }
  /* every Add to cart button tied to this form: the main one inside the form, plus the
     sticky product-quick-add buttons that reference it via the form="..." attribute. */
  function allBuyButtons(form){
    if(!form) return [];
    var set = [];
    form.querySelectorAll('[name="add"], button[type="submit"], .product-form__submit').forEach(function(b){ set.push(b); });
    var fid = form.getAttribute('id');
    if(fid){
      document.querySelectorAll('[form="' + fid + '"]').forEach(function(b){
        if(b.tagName === 'BUTTON' || b.getAttribute('type') === 'submit'){ set.push(b); }
      });
    }
    return set.filter(function(b,i,a){ return a.indexOf(b) === i; });
  }
  function applyLabel(btn, price, compare){
    if(!btn || !price) return;
    var stray = btn.querySelector('.msup-btn-price'); if(stray) stray.remove();
    // locate the "Add to cart" label (a leaf element) and replace it inline
    var label = btn.querySelector('[data-msbase]');
    if(!label){
      var kids = btn.querySelectorAll('*');
      for(var i=0;i<kids.length;i++){
        if(kids[i].children.length===0 && /add to cart/i.test(kids[i].textContent)){
          label = kids[i]; label.setAttribute('data-msbase', (kids[i].textContent||'Add to cart').trim()); break;
        }
      }
    }
    if(!label) return;
    var base = label.getAttribute('data-msbase') || 'Add to cart';
    var html = base + ' <span class="msup-btn-sep">|</span> ' + price;
    if(compare && compare !== price){ html += ' <s class="msup-btn-was">' + compare + '</s>'; }
    label.innerHTML = html;
  }
  function updateButtonPrice(form, price, compare){
    allBuyButtons(form).forEach(function(b){ applyLabel(b, price, compare); });
  }
  /* Direct to checkout: when the picker is active and Add to cart is clicked, add the
     selected variant via AJAX (preserving selling_plan + quantity for Skio) and send the
     shopper straight to /checkout instead of the cart page (higher conversion). Works for
     every plan AND the one-time purchase. Guarded on the picker being visible, and the
     picker only renders for b2c (snippet is tag-gated), so B2B / SparkLayer is untouched. */
  function bindDirectCheckout(form, scope, root){
    if(!form || form.__msCheckout) return; form.__msCheckout = true;
    function handler(e){
      if(!root || root.offsetParent === null) return; // picker hidden (e.g. B2B): leave default behavior
      var idi = idInput(form); var id = idi && idi.value;
      if(!id) return; // nothing selected: let the theme handle it
      e.preventDefault(); e.stopImmediatePropagation();
      var item = { id: Number(id), quantity: qtyValue(scope) };
      var pi = form.querySelector('input[name="selling_plan"][data-ms]');
      if(pi && !pi.disabled && pi.value){ item.selling_plan = Number(pi.value); }
      var btns = allBuyButtons(form);
      btns.forEach(function(b){ b.disabled = true; b.setAttribute('aria-busy','true'); });
      function release(){ btns.forEach(function(b){ b.disabled = false; b.removeAttribute('aria-busy'); }); }
      fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function(r){ return r.json(); })
        .then(function(res){ if(res && (res.items || res.id)){ window.location.href = '/checkout'; } else { release(); } })
        .catch(function(){ release(); });
    }
    allBuyButtons(form).forEach(function(b){ b.addEventListener('click', handler, true); });
    form.addEventListener('submit', handler, true);
  }
  function boot(root){
    if(!root || root.__ms) return; root.__ms = true;
    var form = getForm(root);
    var scope = root.closest('.product-info') || document;
    bindDirectCheckout(form, scope, root);
    var opts = [].slice.call(root.querySelectorAll('.msup__opt'));
    var current = null;
    /* button price always reflects the selected option price x the chosen quantity */
    function refreshButton(){
      if(!current) return;
      var qty = qtyValue(scope);
      var priceRef = current.getAttribute('data-price') || '';
      var compRef = current.getAttribute('data-compare') || '';
      var pc = parseInt(current.getAttribute('data-price-cents'), 10);
      var cc = parseInt(current.getAttribute('data-compare-cents'), 10);
      var price = (pc >= 0 && priceRef) ? fmtMoney(pc * qty, priceRef) : priceRef;
      var compare = (cc > 0 && compRef) ? fmtMoney(cc * qty, compRef) : '';
      updateButtonPrice(form, price, compare);
    }
    function select(opt){
      current = opt;
      opts.forEach(function(o){
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.setAttribute('tabindex', on ? '0' : '-1');
      });
      var vid = opt.getAttribute('data-variant');
      var plan = opt.getAttribute('data-plan');
      var idi = idInput(form);
      if(idi){ idi.value = vid; try{ idi.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
      var pi = planInput(form);
      if(pi){
        if(plan){ pi.value = plan; pi.disabled = false; }
        else { pi.value = ''; pi.disabled = true; }
      }
      refreshButton();
    }
    opts.forEach(function(opt){
      opt.addEventListener('click', function(){ select(opt); });
      opt.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(opt); } });
    });
    /* keep the button price in sync with the theme quantity selector (typing or +/-).
       The quantity-selector sits outside the form, so we listen on the product-info scope. */
    if(scope){
      scope.addEventListener('input', function(e){ if(e.target && e.target.name === 'quantity'){ refreshButton(); } });
      scope.addEventListener('change', function(e){ if(e.target && e.target.name === 'quantity'){ refreshButton(); } });
      scope.addEventListener('click', function(e){ if(e.target && e.target.closest && e.target.closest('quantity-selector')){ setTimeout(refreshButton, 0); } });
    }
    // default-select the flagged option (2-Month / monthly), fallback to first
    var def = opts.filter(function(o){ return o.getAttribute('data-default')==='true'; })[0]
           || opts.filter(function(o){ return o.getAttribute('data-months')==='2'; })[0]
           || opts[0];
    if(def) select(def);
  }
  /* Sticky Add to cart: the theme ships a <product-quick-add> bar but its native
     show/hide observer is not firing here, so we drive it ourselves. Show the bar
     once the main Add to cart has scrolled up out of view; hide it again at the top. */
  function initSticky(){
    document.querySelectorAll('product-quick-add').forEach(function(qa){
      if(qa.__msSticky) return; qa.__msSticky = true;
      // anchor = the main buy buttons (not the ones inside the sticky bar)
      var anchor = null;
      var bbs = document.querySelectorAll('buy-buttons');
      for(var i=0;i<bbs.length;i++){ if(!bbs[i].closest('product-quick-add')){ anchor = bbs[i]; break; } }
      if(!anchor){
        var btns = document.querySelectorAll('.product-form__submit, button[name="add"]');
        for(var j=0;j<btns.length;j++){ if(!btns[j].closest('product-quick-add')){ anchor = btns[j]; break; } }
      }
      if(!anchor) return;
      // Show the bar once the main Add to cart has fully scrolled above the viewport
      // (scrolled down past it); hide it again near the top. A direct scroll handler
      // is reliable even for fast scrolls or anchor jumps. rAF-throttled.
      var ticking = false;
      function update(){
        ticking = false;
        var r = anchor.getBoundingClientRect();
        qa.classList.toggle('is-visible', r.bottom < 0);
      }
      function onScroll(){ if(!ticking){ ticking = true; (window.requestAnimationFrame || window.setTimeout)(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }
  function init(){ document.querySelectorAll('supply-picker.msup').forEach(boot); initSticky(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
